import { put, PutEffect, select, SelectEffect } from 'redux-saga/effects';

import { editorCopy, EditorCutAction } from 'js/actionCreators/editorActions';
import { ExistingScribeModel } from 'js/types';
import { showError } from 'js/actionCreators/uiActions';
import { deleteMultipleElementsById, deleteSelectedScenes, setActiveElements } from 'js/actionCreators/scribeActions';

import { getActiveElements, getScribeById } from '../selectors';

export function* cut({
  scribeId
}: EditorCutAction): Generator<SelectEffect | PutEffect, void, (ExistingScribeModel | undefined) | string[]> {
  const scribe = (yield select(getScribeById, scribeId)) as ExistingScribeModel | undefined;
  const activeElementIds = (yield select(getActiveElements)) as string[];

  if (!scribe) {
    return;
  }

  let displayNoDeleteMessage = false;
  const filteredElements = activeElementIds.filter(element => {
    if (scribe.scenes.some(scene => scene.elementIds[0] === element)) {
      displayNoDeleteMessage = true;
      return false;
    }
    return true;
  });

  if (displayNoDeleteMessage) {
    yield put(
      showError({
        message: "A scene's starting camera cannot be deleted or rearranged."
      })
    );
  }

  const selectedSceneIds = (yield select(state => state.scribes.selectedSceneIds)) as string[];
  const hasScenesSelected = !!selectedSceneIds.length;
  const hasElementsSelected = !!filteredElements.length;

  if (
    (!hasScenesSelected && !hasElementsSelected) ||
    (hasScenesSelected && !(selectedSceneIds.length < scribe.scenes.length))
  )
    return;

  yield put(editorCopy(scribeId, true));

  if (hasScenesSelected) {
    yield put(deleteSelectedScenes(scribeId));
  } else {
    yield put(setActiveElements([]));
    yield put(deleteMultipleElementsById(filteredElements, scribeId));
  }
}
